import { render } from "./Child-Search.vue?vue&type=template&id=483be688&scoped=true"
import script from "./Child-Search.vue?vue&type=script&lang=js"
export * from "./Child-Search.vue?vue&type=script&lang=js"

import "./Child-Search.vue?vue&type=style&index=0&id=483be688&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483be688"]])

export default __exports__